<template>
  <el-table :data="tableData" border :header-cell-style ="{color: '#606266'}"  >
    <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
    <el-table-column prop="orderNum" label="订单号" align="center" min-width="200px" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="iccid" label="ICCID" align="center" min-width="158px" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="payMoney" label="订单金额" align="center" min-width="100px" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="productName" label="套餐名" align="center" min-width="158px"></el-table-column>
    <el-table-column prop="operationName" label="运营商" align="center" min-width="158px"></el-table-column>
    <el-table-column prop="payTime" label="支付时间" align="center" min-width="158px"></el-table-column>
    <el-table-column prop="createTime" label="创建时间" align="center" min-width="158px"></el-table-column>
  </el-table>
</template>
<script>
import { invoiceOrderList} from "@/api/api.js"; //资费列表
export default {
  props: {
    invoiceid: {
      type: [Number]
    }
  },
  data() {
    return{
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
    }
  },
  computed: {
    adminShow : {
      get() {
        return this.$store.getters.user.userType =='1'
      }
    },
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params = {
        invoiceId:this.invoiceid
      };
      invoiceOrderList(params).then(res => {
        if(res.data.code == 200){
          this.tableData = res.data.data;
        }
      })
    },
  },
  activated() {
    this.initData();
  }
};
</script>

<style scoped lang="less">

</style>


